module.exports = __webpack_public_path__ + "img/thinkScrn1.261f9ad4.png";